import { ComponentType } from 'react';
import styled from 'styled-components';
import { IonText } from '@ionic/react';
import { AllieTextProps } from './Text.types';

export const AllieTextWrapper = styled.div<{ $hoverColor?: string }>`
  ${({ $hoverColor }) =>
    $hoverColor &&
    `transition: color 0.2s ease;
    &:hover {
      color: var(--allie-color-${$hoverColor});
    }`}
`;

export const AllieTextStyled: ComponentType<AllieTextProps> = styled(IonText)`
  ${({ lineClamp }) =>
    lineClamp &&
    `text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: ${lineClamp};
    display: -webkit-box;
    -webkit-box-orient: vertical;`};
`;
